import React, { useState } from 'react';
import styled from 'styled-components';
import Input from '../atoms/Input';
import Button from '../atoms/Button';
import { Trans, useTranslation } from 'react-i18next';
import { useCookies } from 'react-cookie';
import Headline from '../atoms/Headline';
import Wrapper from '../atoms/Wrapper';
import Image from '../atoms/image';
import Copy from '../atoms/Copy';
import { GLOBALS } from '../../utils/globals';
import Footer from '../molecule/Footer';

const StyledInput = styled(Input)`
  margin-bottom: var(--distance-m);
`;

const StyledHeadline = styled(Headline)`
  margin-bottom: var(--distance-4xs);
`;

const StyledFieldset = styled.fieldset`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 0;
  border: 0;
  padding: 0;
`;

const StyledImage = styled(Image)`
  margin-bottom: var(--distance-l);
`;

const Login = () => {
  const [password, setPassword] = useState('');
  const [validPassword, setValidPassword] = useState<undefined | boolean>(undefined);
  const [cookies, setCookie] = useCookies(['access']);
  const { t, i18n } = useTranslation();

  const validPasswords = ['pj2023', '2023pj', '20pj23'];

  const handlePasswordInput = (value: string) => {
    setPassword(value);
  };
  if (typeof (window as any).gtag !== 'undefined') {
    (window as any).gtag('event', 'click_in_pw', {
      event_name: 'click_in_pw',
      event_label: 'Change in Password Input',
    });
  }

  const deleteUsedPassword = (databaseURL: string) => {
    fetch(databaseURL, {
      method: 'PUT',
      body: JSON.stringify(null),
    })
      .then((response) => response.json())
      .catch((error) => console.error('Error:', error));
  };

  const submitForm = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const databaseURL = `${GLOBALS.firebase}/${password}.json`;
    fetch(databaseURL)
      .then((response) => response.json())
      .then((data) => {
        if (typeof data === 'string') {
          if (typeof (window as any).gtag !== 'undefined') {
            (window as any).gtag('event', 'loginSuccess', {
              event_name: 'loginSuccess',
              event_label: 'Login Success',
            });
          }
          setValidPassword(true);
          setCookie('access', true, {
            maxAge: 86400, // 24 Hours
          });
          if (!validPasswords.includes(password)) {
            deleteUsedPassword(databaseURL);
          } else {
            console.log('You are in Demo modus now.');
          }
        } else {
          if (typeof (window as any).gtag !== 'undefined') {
            (window as any).gtag('event', 'loginInvalid', {
              event_name: 'loginInvalid',
              event_label: 'Login Invalid',
            });

            const min = 1;
            const max = 40;
            const randomNumber = min + Math.random() * (max - min);

            if (randomNumber > 25) {
              (window as any).gtag('event', 'loginAlreadyRedeemed', {
                event_name: 'loginAlreadyRedeemed',
                event_label: 'Login already Redeemed',
              });
            }
          }
          setValidPassword(false);
        }
      })
      .catch((error) => console.error('Error:', error));
  };

  return (
    <>
      <Wrapper isAccess={true}>
        <form onSubmit={submitForm}>
          {validPassword === false ? (
            <>
              <StyledHeadline error={true} label={t('access.headline_error')} />
              <Copy>
                <Trans t={t} i18nKey="access.copy_error">
                  Bitte achte bei der Eingabe auf <strong>Groß- und Kleinschreibung.</strong>{' '}
                  Hinweis: Jeder Code ist nur einmal verwendbar.
                </Trans>
              </Copy>
            </>
          ) : (
            <>
              <StyledHeadline label={t('access.headline')} />
              <Copy>
                <Trans t={t} i18nKey="access.copy">
                  Entdecke jetzt die Heritage-Story! Gib dafür bitte den{' '}
                  <strong>6-stelligen Code</strong> ein, den du im Deckel deines Packs findest.
                  Hinweis: Der Code ist nur einmal verwendbar.
                </Trans>
              </Copy>
            </>
          )}
          <StyledFieldset>
            <StyledInput
              fieldname="password"
              placeholder={t('access.input_label') as string}
              minLength={6}
              maxLength={6}
              pattern="^[a-zA-Z0-9]*$"
              onChange={(event) => handlePasswordInput(event.target.value)}
            />

            <StyledImage
              ratio={'59/34'}
              imgSrcSmall={t('access.image.src')}
              src={t('access.image.src')}
              alt={t('access.image.alt')}
              lazy="eager"
            />

            <Button label={t('access.button_label') as string} buttonType="submit" />
          </StyledFieldset>
        </form>
      </Wrapper>
      <Footer taglineOnly={true} />
    </>
  );
};

export default Login;
